import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { GAME_TYPES_TYPE, OPERAND_TYPE } from '../../../../constants/constants';
import { EGymAssessmentMode } from '../../../../utils/gymUtils';

// --------------------
// GraphQL Mutation
// --------------------
const mutation = gql`
  mutation incrementGymAssessmentPracticeGamesPlayed(
    $input: IncrementGymAssessmentPracticeGamesPlayedInput!
  ) {
    incrementGymAssessmentPracticeGamesPlayed(input: $input) {
      _id
      userId
      gameType
      assessmentMode
      played
      highScore
      correctCount
      questionsTaken
      timeSec
      correctAnswers {
        left {
          a
          x
          b
          c
          y
        }
        right {
          a
          x
          b
          c
          y
        }
      }
      wrongAnswers {
        left {
          a
          x
          b
          c
          y
        }
        right {
          a
          x
          b
          c
          y
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// --------------------
// TypeScript Types
// --------------------

export interface AnswerInput {
  left: OPERAND_TYPE;
  right: OPERAND_TYPE;
}

export interface IncrementGymAssessmentPracticeGamesPlayedInput {
  userId: string;
  gameType: GAME_TYPES_TYPE;
  assessmentMode: EGymAssessmentMode;
  highScore: number;
  correctCount: number;
  questionsTaken: number;
  timeSec: number;
  correctAnswers?: AnswerInput[];
  wrongAnswers?: AnswerInput[];
}

export interface Answer {
  left: OPERAND_TYPE;
  right: OPERAND_TYPE;
}

export interface GymAssessmentPracticeGame {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  assessmentMode: EGymAssessmentMode;
  played: number;
  highScore: number;
  correctCount: number;
  questionsTaken: number;
  timeSec: number;
  correctAnswers: Answer[][];
  wrongAnswers: Answer[][];
  createdAt: string;
  updatedAt: string;
}

export interface MutationType {
  incrementGymAssessmentPracticeGamesPlayed: GymAssessmentPracticeGame;
}

// --------------------
// Hook
// --------------------
export function useIncrementGymAssessmentPracticeGamesPlayedMutation(
  options?: MutationHookOptions<
    MutationType,
    { input: IncrementGymAssessmentPracticeGamesPlayedInput }
  >,
) {
  return useMutation<MutationType, { input: IncrementGymAssessmentPracticeGamesPlayedInput }>(
    mutation,
    options,
  );
}
